import { useState } from "react";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { InventoryTable } from "@/components/inventory/inventory-table";
import { EditableInventoryTable } from "@/components/inventory/editable-inventory-table";

interface InventorySearchParams {
  action?: string;
  ndc?: string;
  itemName?: string;
  search?: string;
}

export const Route = createFileRoute("/_app/inventory")({
  component: InventoryPage,
  validateSearch: (search: Record<string, unknown>): InventorySearchParams => ({
    action: search.action as string | undefined,
    ndc: search.ndc as string | undefined,
    itemName: search.itemName as string | undefined,
    search: search.search as string | undefined,
  }),
});

function InventoryPage() {
  const [isBulkAdding, setIsBulkAdding] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const search = useSearch({ from: "/_app/inventory" });

  if (isBulkAdding) {
    return (
      <EditableInventoryTable
        onBulkSaveSuccess={() => {
          setIsBulkAdding(false);
          setRefreshKey((k) => k + 1);
        }}
        onCancel={() => setIsBulkAdding(false)}
      />
    );
  }

  return (
    <InventoryTable
      key={refreshKey}
      onStartBulkAdd={() => setIsBulkAdding(true)}
      initialSearch={search.search}
      initialDispense={
        search.action === "dispense" && search.ndc
          ? { ndc: search.ndc, itemName: search.itemName || "" }
          : undefined
      }
    />
  );
}
